import { AuthGuard } from '../../../shared/services';
import { PartenairesDetailsComponent } from './partenaires-details.component';
import { PartenairesDetailsResolver } from './partenaires-details.resolver';
import {Route} from '@angular/router';

export const PartenairesDetailsRoutes: Route[] = [
  {
    path: ':id',
    component: PartenairesDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      partner: PartenairesDetailsResolver
    }
  }
];
